/**
 * Pure CHF -> target multiplication. No rounding here — rounding is done
 * separately by roundPrice() so callers can round line items individually
 * before summing (see useDisplayPriceSum).
 */
export function convertPrice(chf: number, rateChfTo: number): number {
  if (!isFinite(chf) || !isFinite(rateChfTo) || rateChfTo <= 0) return 0;
  return chf * rateChfTo;
}